import { CalendarProps } from "@/interfaces/calendar_type";
import { MonthDayCard } from "./MonthDayCard";

/**
 * Component that layouts and renders each day of the month
 * @param {number} daysInMonth
 * @param {Date} currentMonth
 * @param {CalendarProps[]} projectList
 */

export function MonthLayout({ currentMonth, projectList }: { daysInMonth: number; currentMonth: Date; projectList: CalendarProps[]; }) {
    // Pads days to the beginning of the month
    const days_to_skip = () => {
        const tempMonth = currentMonth;
        tempMonth.setDate(1);
        const day = tempMonth.toLocaleDateString('en-US', { weekday: 'long' });

        switch (day) {
            case 'Monday':
                return 1;
            case 'Tuesday':
                return 2;
            case 'Wednesday':
                return 3;
            case 'Thursday':
                return 4;
            case 'Friday':
                return 5;
            case 'Saturday':
                return 6;
            default:
                return 0;
        }
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-7 gap-2">

            {Array.from({ length: days_to_skip() }, (_, index) => (
                <div key={index} className="p-14 border border-gray-300 bg-gray-200 dark:bg-stone-800 text-center" />
            ))}

            {projectList.map((project_day, index) => (
                <MonthDayCard key={index} day_number={project_day.day} projects={project_day.projects} />
            ))}
        </div>
    );
}
